import { connect } from 'react-redux';
import CrudTable from '../components/CrudTable/CrudTable';
import AiContext from '../components/AiContext/AiContext';
import NewFormDialog from '../components/AiContext/AiContextNewFormDialog';
import * as actions from '../actions/aiContextsActionCreators';
import { bindActionCreators } from 'redux';
import { set } from 'lodash';

const mapStateToProps = (state, props) => {
  console.log(state)
  return ({
  ...state,
  listData: state.ai_contexts,
  title: 'AI Contexts',
  NewFormDialog,
  CrudRow: AiContext,
})
};

export default connect(mapStateToProps, actions)(CrudTable);
